import Axios from "axios";
import { SETTINGS } from "../../properties/ApiProps";

export const VacancyRepository = {
  save: (data) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancies`,
      method: "POST",
      data: data,
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
    });
  },
  findById: (id) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancies/${id}`,
      method: "GET",
    });
  },
  findAllByType: () => {
    return Axios({
      url: SETTINGS.API_URL + "vacancies/byType",
      method: "GET",
    });
  },
  fetchAllVacancy: (payload) => {
    return Axios({
      url: `${SETTINGS.API_URL}vacancies`,
      method: "GET",
      headers: {
        Authorization: SETTINGS.API_AUTHORIZATION_HEADER,
      },
      params: {
        page: payload.page,
        size: payload.size,
        orderBy: payload.orderBy,
        orderDirection: payload.orderDirection,
        filterProperty: payload.filterBy,
        filterValue: payload.filterValue,
      },
    });
  },
};
